
import { defineComponent } from 'vue';
import packageInfo from '../../../package.json';

export default defineComponent({
  data(): { version: string } {
    return {
      version: packageInfo.version,
    };
  },
});
